import { TenantDropdownItem } from "@saleor/products/customTypes/TenantDropdownItem";
import { SearchBrandsPrivate_search_edges_node_tenants } from "@saleor/searches/types/SearchBrandsPrivate";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import _ from "lodash";
import { useEffect, useState } from "react";

export default function useTenantUpdate(
  tenants: SearchBrandsPrivate_search_edges_node_tenants[],
  brand,
  userView,
  params
): [(e) => void, TenantDropdownItem, TenantDropdownItem[]] {
  const [tenant, setTenant] = useState<TenantDropdownItem>({
    label: "",
    value: { mallId: "", tenantId: "" }
  });

  const mappedTenants = _.uniq(
    tenants.map(tenant => ({
      brandId: tenant.brand.id,
      mallId: tenant.mall.id,
      tenantId: tenant.id,
      tenantName: tenant.storeName
    }))
  );

  const tenantChoices = _.uniq(
    mappedTenants
      .filter(m => m.brandId === brand)
      .map(t => ({
        label: t.tenantName,
        value: {
          mallId: t.mallId,
          tenantId: t.tenantId
        }
      }))
  );

  useEffect(() => {
    // If params for store admin query are available..
    // Set the tenant value by param values
    // Else, set the tenant value by query results
    if (
      userView === SmopUserTypeCode.STORE_ADMIN &&
      mappedTenants.length > 0 &&
      params.brand !== undefined &&
      params.brand === brand &&
      params.tenant !== undefined &&
      params.mallId !== undefined
    ) {
      const selectedTenant = mappedTenants.filter(
        t => t.tenantId === params.tenant
      )[0];
      setTenant({
        label: selectedTenant.tenantName,
        value: {
          mallId: params.mallId,
          tenantId: params.tenant
        }
      });
    } else if (
      // brand state changed while in store admin view
      userView === SmopUserTypeCode.STORE_ADMIN &&
      mappedTenants.length > 0 &&
      params.brand !== undefined &&
      params.brand !== brand &&
      brand !== ""
    ) {
      // Set to initial brand's tenant
      const selectedBrand = mappedTenants.filter(t => t.brandId === brand)[0];
      setTenant({
        label: selectedBrand.tenantName,
        value: {
          mallId: selectedBrand.mallId,
          tenantId: selectedBrand.tenantId
        }
      });
    } else if (
      userView === SmopUserTypeCode.STORE_ADMIN &&
      mappedTenants.length > 0 &&
      brand !== ""
    ) {
      const selectedBrand = mappedTenants.filter(t => t.brandId === brand)[0];
      setTenant({
        label: selectedBrand.tenantName,
        value: {
          mallId: selectedBrand.mallId,
          tenantId: selectedBrand.tenantId
        }
      });
    }
  }, [userView, brand, mappedTenants.length]);

  const handleTenantChange = e => {
    const id = e.target.value.tenantId;
    const selectedTenant = mappedTenants.filter(m => m.tenantId === id)[0];
    setTenant({
      label: selectedTenant.tenantName,
      value: {
        mallId: selectedTenant.mallId,
        tenantId: selectedTenant.tenantId
      }
    });
  };

  return [handleTenantChange, tenant, tenantChoices];
}
